import { useSelector } from 'react-redux';

export function InlineNewThreadButton() {
  const { status } = useSelector((state) => state.auth);
  const authenticated = status === 'authenticated';

  return (
    <div className="px-4 py-3">
      {authenticated ? (
        <button
          id="loginToCreateThread"
          onClick={(e) => {
            document.getElementById('newThreadDialog').showModal();
          }}
          className="not-prose mt-4 mb-2 w-full overflow-hidden rounded-2xl bg-inherit px-4 py-3 text-left text-gray-900/50 [word-break:break-word] dark:text-gray-100/60"
        >
          Type a new thread title...
        </button>
      ) : (
        <button
          id="loginToCreateThread"
          onClick={(e) => {
            document.getElementById('loginDialog').showModal();
          }}
          className="not-prose mt-4 mb-2 w-full overflow-hidden rounded-2xl bg-inherit px-4 py-3 text-left text-gray-900/50 [word-break:break-word] dark:text-gray-100/60"
        >
          Type a new thread title...
        </button>
      )}
    </div>
  );
}
